import LoadingPlaceholder from './LoadingPlaceholder';
import LoadingPlaceholderV2 from '../../lego.editor_comment/LoadingPlaceholder';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    editor_comment: LoadingPlaceholderV2
})(LoadingPlaceholder);

//# sourceMappingURL=index.js.map